export default __webpack_public_path__ + "static/media/mr_ms_smith.a23a4fbb.svg";